/*eslint-disable*/
export default waitlistCTA => {
  let $successMessage = $('.waitlist-success')
  let $waitlistOverlay = $('body').find('#waitlist-tab-overlay')
  
  $(waitlistCTA).click(() => {
    $('#wrapper .content.container').css('overflow', 'hidden')
    $('body').css('overflow', 'hidden')
    $('#wrapper').css('overflow', 'hidden')
    $successMessage.removeClass('success')
    const buildWaitlistForm = document.getElementById('waitlist-form')
    buildWaitlistForm.classList.remove('hide')
    buildWaitlistForm.elements["Product SKU"].value = event.target.dataset.productSku
    buildWaitlistForm.elements["Product SKU"].defaultValue = event.target.dataset.productSku
    buildWaitlistForm.elements["Product ID"].value = event.target.dataset.productId
    buildWaitlistForm.elements["Product ID"].defaultValue = event.target.dataset.productId
    buildWaitlistForm.elements["Product Title"].value = event.target.dataset.productTitle
    buildWaitlistForm.elements["Product Title"].defaultValue = event.target.dataset.productTitle
    buildWaitlistForm.elements["Variant Title"].value = event.target.dataset.productVariantTitle
    buildWaitlistForm.elements["Variant Title"].defaultValue = event.target.dataset.productVariantTitle
    buildWaitlistForm.elements["Full Title"].value = event.target.dataset.fullTitle
    buildWaitlistForm.elements["Full Title"].defaultValue = event.target.dataset.fullTitle
    $waitlistOverlay.addClass('is-active')
    setTimeout(() => {
      $('body').on('click.waitlistEvent touchstart.waitlistEvent', function (e) {
        e.stopImmediatePropagation()
        if (!$(e.target).closest('#waitlist-tab-modal:not(.template)').length) {
          $waitlistOverlay.removeClass('is-active')
          $('body').off('click.waitlistEvent touchstart.waitlistEvent')
          $('body').css('overflow', 'auto')
          $('#wrapper').css('overflow', 'auto')
          $('#wrapper .content.container').css('overflow', 'auto')
        }
      })
    }, 10)
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/waitlist-cta.js